/*
    Monday Task: 8478222625 - Buy Button Profile Listing
*/

import React from "react";
import Moment from "react-moment";

const ProfileTableData = ({ profileRowData }) => {
    return (
        <tr key={profileRowData.id}>
            {/* Profile Name */}
            {/* <td className="pl-3 pr-3 ">{profileRowData?.profile_name}</td> */}
            <td style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", maxWidth: "320px" }} className="pl-3 pr-3" title={profileRowData?.profile_name}>
                <a
                    style={{ fontWeight: "bold" }}
                    href={
                        window.env.API_URL +
                        'buy-button-profile/' +
                        profileRowData?.id
                      }>
                    {profileRowData?.profile_name}
                </a>
            </td>

            {/* Products that associated with Profile */}
            <td className="pl-1 pr-1"
                style={{
                    maxWidth: "200px", 
                    wordWrap: "break-word",
                    whiteSpace: "normal"
                }}>
                {profileRowData?.product_names?.length > 0 ? (
                    <ul style={{ listStyleType: "none", padding: 0, margin: 0 }}>
                        {profileRowData.product_names.map((productName, index) => (
                            <li key={index} style={{ marginBottom: "5px", fontSize: "16px" }}>
                                <a href={`/product-details?productId=${productName.id}`} target="_blank" rel="noopener noreferrer"
                                    style={{ textDecoration: "none", color: "#007bff" }}
                                >
                                    {productName.name}
                                </a>
                            </li>
                        ))}
                    </ul>
                ) : "-"}
            </td>

            {/* Monday Task: 8899629353 - Store Name */}
            <td className="pl-1 pr-1">{profileRowData?.store_name || "-"}</td>

            {/* Monday Task: 8899629353 - Store Vanity URL */}
            <td className="pl-1 pr-1">{profileRowData?.store_url || "-"}</td>

            {/* Date Created */}
            <td className="pl-1 pr-1">
                {profileRowData?.created_at ? (
                    <Moment format="MM/DD/YYYY" withTitle>
                        {profileRowData?.created_at}
                    </Moment>
                ) : (
                    "-"
                )}
            </td>
            
            {/* Date Updated */}
            <td className="pl-1 pr-1">
                {profileRowData?.updated_at ? (
                    <Moment format="MM/DD/YYYY" withTitle>
                        {profileRowData?.updated_at}
                    </Moment>
                ) : (
                    "-"
                )}
            </td>

            {/* User */}
            <td className="pl-1 pr-1">{profileRowData?.owner_name || "-"}</td>

            {/* Button Color */}
            <td className="pl-1 pr-1"><div style={{ width: "32px", height: "32px", backgroundColor: profileRowData?.button_background }}></div></td>

            {/* Button Text */}
            <td className="pl-1 pr-1">{profileRowData?.button_text || "-"}</td>
        </tr>
    );
};

export default ProfileTableData;
